import {GridWidgetFilter} from './grid-widget-filter';
import {SelectField} from './select-field';
import { pdsUtils } from '../../../src/pds-utils';
import {RestArgument} from './rest-argument';

export class SelectFilter extends GridWidgetFilter {

  static blankObject = {
    toString(): string {
      return 'blank object';
    }
  };

  //This holds the Actual value of the search, not the
  //label for it that shows up in the UI drop-down.
  searchValue: any;

  isBlank(): boolean {
    return this.searchValue == null || this.searchValue === SelectFilter.blankObject;
  }

  internalPassesFilter(dataFromDataRow: any): boolean {
    return dataFromDataRow === this.searchValue;
  }

  preFilterUpdate(): void {
  }

  getTagName(): string {
    return 'pds-gw-select-filter';
  }

  setQuickSearchValue(text: string): boolean {
    this.searchValue = undefined;
    let valid = false;
    if (text != null && text !== '') {
      //We need to run through all of the options in case one more completely matches the other.
      (<SelectField>this.dataField).selectOptions.forEach((value, key) => {
        if (key.toUpperCase().search(pdsUtils.escapeUserInput(text.toUpperCase())) >= 0) {
          valid = true;
          //If searchValue hasn't been set, then no need to compare.
          //If searchValue has already been set, then don't set it again unless the new value
          //has less letters (Therefore a larger percentage of the word has been matched).
          if (this.searchValue == null || value.length < this.searchValue.length) {
            this.searchValue = value;
          }
        }
      });
    }

    return valid;
  }

  getRestArguments(): Array<RestArgument> {
    if (this.isBlank()) {
      return [];
    }

    return [
      new RestArgument(this.dataField.id, '=', this.searchValue)
    ];
  }

  getTagText(): string {
    let answer = (<SelectField>this.dataField).selectOptions.find((value, key) => {
      return this.searchValue === value;
    });
    if (answer == null) {
      return 'blank'; //we need to make sure this does not happen.
    }
    return answer.key;
  }

  getPersistenceObject(): Object | undefined {
    return this.searchValue;
  }

  restoreFromPersistenceObject(value: Object): void {
    this.searchValue = <string>value;
  }
}
